var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13225_64065)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2143 24.5719C9.72619 24.5719 8.33254 24.2923 7.03333 23.7333C5.73333 23.1743 4.59722 22.4056 3.625 21.4273C2.65278 20.449 1.88889 19.3058 1.33333 17.9977C0.777778 16.6904 0.5 15.288 0.5 13.7906C0.5 12.2932 0.777778 10.8905 1.33333 9.58233C1.88889 8.275 2.65278 7.13219 3.625 6.15389C4.59722 5.17559 5.73333 4.40693 7.03333 3.8479C8.33254 3.28887 9.72619 3.00936 11.2143 3.00936C11.631 3.00936 12.0325 3.03412 12.419 3.08363C12.8063 3.13394 13.1984 3.20901 13.5952 3.30884V5.76457C13.1984 5.64478 12.8063 5.55493 12.419 5.49504C12.0325 5.43514 11.631 5.40519 11.2143 5.40519C8.87302 5.40519 6.89881 6.21379 5.29167 7.83097C3.68452 9.44816 2.88095 11.4347 2.88095 13.7906C2.88095 16.1465 3.68452 18.1331 5.29167 19.7502C6.89881 21.3674 8.87302 22.176 11.2143 22.176C13.5556 22.176 15.5298 21.3674 17.1369 19.7502C18.744 18.1331 19.5476 16.1465 19.5476 13.7906C19.5476 13.571 19.5377 13.3713 19.5179 13.1917C19.498 13.012 19.4683 12.8123 19.4286 12.5927H21.869C21.9087 12.8123 21.9286 13.012 21.9286 13.1917V13.7906C21.9286 15.288 21.6508 16.6904 21.0952 17.9977C20.5397 19.3058 19.7758 20.449 18.8036 21.4273C17.8313 22.4056 16.6956 23.1743 15.3964 23.7333C14.0964 24.2923 12.7024 24.5719 11.2143 24.5719ZM19.5476 10.1969V6.60311H15.9762V4.20728H19.5476V0.613525H21.9286V4.20728H25.5V6.60311H21.9286V10.1969H19.5476ZM14.5476 18.8219L10.0238 14.2698V7.80103H12.4048V13.3114L16.2143 17.1448L14.5476 18.8219Z",
    fill: "grey"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13225_64065",
    x1: -2.61562,
    y1: 8.92318,
    x2: 25.0989,
    y2: 19.7923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--gradient-start)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--gradient-end)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13225_64065"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(0.5 0.0927734)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.cc359696fc005104c3d1286efd38884f.svg";
export { ForwardRef as ReactComponent };